import { PromoCode } from "../../../types/promoCode";
import { Link } from "react-router-dom";
import { Badge } from "../../../components/Badge";
import { ColDef } from "ag-grid-community";
import React from "react";
import moment from "moment";
import { usdFormat } from "../../../utils";

type CellRenderer = (params: {
  value:
    | string
    | number
    | boolean
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>
    | React.ReactFragment
    | React.ReactPortal
    | null
    | undefined;
  data: PromoCode;
}) => JSX.Element;

const createCellRenderer = (
  permission: boolean,
  linkFunc: (params: { data: PromoCode }) => string
): CellRenderer => {
  return (params) => (
    <>
      {permission ? (
        <Link to={linkFunc(params)}>
          <Badge>{params.value}</Badge>
        </Link>
      ) : (
        <Badge>{params.value}</Badge>
      )}
    </>
  );
};

const generateColDefs = (): ColDef<PromoCode>[] => [
  {
    headerName: "Promo Code",
    valueGetter: (p) => p.data?.uid,
    cellRenderer: createCellRenderer(true, (p) => `/promocode/${p.data.id}/edit`),
  },
  {
    headerName: "Description",
    valueGetter: (p) => p.data?.description,
  },
  {
    headerName: "Type",
    valueGetter: (p) =>
      p.data?.promo_payload?.promo_code_value_type === "percentage_off"
        ? "Percentage Off"
        : "Amount Off",
  },
  {
    headerName: "Value",
    valueGetter: (p) => {
      if (p.data?.promo_payload?.promo_code_value_type === "percentage_off") {
        return p.data?.promo_payload?.percentage
          ? `${((p.data.promo_payload.percentage || 0) * 100).toFixed(2)}%`
          : "-";
      } else {
        return p.data?.promo_payload?.amount
          ? usdFormat.format((p.data.promo_payload.amount ?? 0) / 100)
          : "-";
      }
    },
  },
  {
    headerName: "Is Used",
    valueGetter: (p) => (p.data?.is_used ? "Yes" : "No"),
  },
  {
    headerName: "Unlimited Usage",
    valueGetter: (p) => (p.data?.unlimited_usage ? "Yes" : "No"),
  },
  {
    headerName: "Balance",
    valueGetter: (p) => p.data?.balance,
  },
  {
    headerName: "Event",
    valueGetter: (p) => p.data?.event?.name,
  },
  {
    headerName: "Created Date",
    valueGetter: (p) => p.data?.created_at,
    valueFormatter: (p) => {
      const date = p.value ? moment(p.value) : null;
      return date ? date.format("MM/DD/YYYY h:mm:ss a") : "";
    },
  },
];

export const promoCodesColDefs: ColDef<PromoCode>[] = generateColDefs();